'use strict' ;
angular.module('Khayrokom') .service('modalService' , ['$uibModal' , function($uibModal){

    var currentModal = {} ;
    this.createModal = function(modalURL , modalController){
        var modalInstance =   this.createModalWithScope(template ,modalController , null) ;
        return modalInstance ;
    } ;
    this.createModal = function(template , modalController,scope){
        var modalInstance =   this.createModalWithScope(template ,modalController , scope) ;
        return modalInstance ;
    } ;
    this.createModalWithScope = function(template , modalController , scope){
        var modalInstance = $uibModal.open({
            animation : true ,
            template ,
            controller : modalController ,
            scope:scope
        }) ;
        return modalInstance ;
    } ;
     this.setCurrentModal = function(modalInstance){
         currentModal = modalInstance ;
     } ;
     this.getCurrentModal = function(){
         return currentModal ;
     } ;
}]);



// WEBPACK FOOTER //
// ./js/services/modalService.js